export default __webpack_public_path__ + "static/SRF 3260ACS25 - Fiche de spécifications et données techniques-c25e82ac51e7c4610d68bd97d45c3903.pdf";